import { render, staticRenderFns } from "./TaskPriorityMenu.vue?vue&type=template&id=36b2101d"
import script from "./TaskPriorityMenu.vue?vue&type=script&lang=ts"
export * from "./TaskPriorityMenu.vue?vue&type=script&lang=ts"
import style0 from "./TaskPriorityMenu.vue?vue&type=style&index=0&id=36b2101d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports